define.alias("shared/utils/string-formatters/dashed-to-camel", "media/utils/string-formatters/dashed-to-camel");